import React from 'react';
import PropTypes from 'prop-types';

import { ReactComponent as FilterIcon } from '#/assets/icons/filter.svg';
import styles from './styles.module.css';

import { useTranslation } from "react-i18next";


function FilterButton({ toggle, isOpen, filters, customStyleClass, sizeIcon = 22, bgColor, Icon = FilterIcon, styleIcon = {}}) {

  const { t } = useTranslation();

  let sizeBtn = sizeIcon + 16;

  function renderActiveFilters() {
    const allFilter = Object.values(filters);
    const count =
      allFilter[0].length +
      allFilter[1].length +
      allFilter[2].length +
      allFilter[3].length;
    return count ? count : '';
  }

  let  btnConf = {
    width: sizeBtn,
    height: sizeBtn
  }

  if(bgColor) {
    btnConf['backgroundColor'] = bgColor;
  }

  return (
    <button
      style={btnConf}
      onClick={toggle}
      className={[customStyleClass ? customStyleClass : '', styles.button, isOpen ? styles.isOpen : ''].join(' ')}
    >
      {filters && renderActiveFilters() > 0 && (
        <span className={styles.filterNumber}>{renderActiveFilters()}</span>
      )}
      <Icon 
        className={styles.icon}
        alt={t('ACTION_ICON')}
        style={{
          ...styleIcon,
          width: sizeIcon,
          height: sizeIcon,
          marginTop: 8
        }}
      />
    </button>
  );
}

FilterButton.propTypes = {
  toggle: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  filters: PropTypes.object,
};

export default FilterButton;
